/* tslint:disable */
/* eslint-disable */
/**
 * SI Implicit-Bias API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ImplicitBiasResultInterpretation {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3,
    NUMBER_4 = 4
}

export function ImplicitBiasResultInterpretationFromJSON(json: any): ImplicitBiasResultInterpretation {
    return ImplicitBiasResultInterpretationFromJSONTyped(json, false);
}

export function ImplicitBiasResultInterpretationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImplicitBiasResultInterpretation {
    return json as ImplicitBiasResultInterpretation;
}

export function ImplicitBiasResultInterpretationToJSON(value?: ImplicitBiasResultInterpretation | null): any {
    return value as any;
}

